import { render, staticRenderFns } from "./edit-gallery.vue?vue&type=template&id=53658b6b&scoped=true&"
import script from "./edit-gallery.vue?vue&type=script&lang=ts&"
export * from "./edit-gallery.vue?vue&type=script&lang=ts&"
import style0 from "./edit-gallery.vue?vue&type=style&index=0&id=53658b6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53658b6b",
  null
  
)

export default component.exports